import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EasBuilderForm, EasBuilderTransition, EasFormWFGroup, EasWorkflowContext } from './builder.interfaces';
import { WorkflowService } from './workflow.service';
import { User } from '@fry/lib/users';

/** Builder service wraps most common actions into single calls */
@Injectable({
  providedIn: 'root'
})
export class BuilderService {

  constructor(
    private workflow: WorkflowService
  ) {
  }

  buildWFForm(_wfForm: EasBuilderForm,
              _model: any,
              _data: any,
              _wfContext: EasWorkflowContext,
              _owner: string,
              _user: User): Observable<EasFormWFGroup> {

    throw new Error('Deprecated: User BuilderStateService');
  }

  collectTransitionData(transition: EasBuilderTransition, data: any) {
    return this.workflow.collectTransitionData(transition, data);
  }
}
